/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthenService } from './core/services/authen.service';
import {
    SUPPORT_THEMES_CLASS,
    SurveyForceStoreService,
} from './core/services/survey-force-store.service';
import { APP_PATH } from './modules/common/enum-constant';

@Injectable({
    providedIn: 'root',
})
export class SurveyForceInitialDataResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(
        private _authenService: AuthenService,
        private _storeService: SurveyForceStoreService,
        private _title: Title
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        this._storeService.handleAppHeight();
        let isGetData = false;
        const surveyData = this._storeService.getSurveyData();
        this._addTheme();
        if (
            state.url.includes(`/${APP_PATH.SURVEY_FORCE_QUIZ}`) ||
            state.url.includes(`/${APP_PATH.SURVEY_FORCE}`) ||
            state.url.includes(`/${APP_PATH.START}`)
        ) {
            if (!surveyData) {
                isGetData = true;
            }
        }
        if (isGetData) {
            console.log('App is getting Survey API !!!');
            this._storeService.showLoadingBar();
            return this._authenService.getSurvey().pipe(
                map(({ data = null, meta = null }) => {
                    let error = '';
                    if (meta && meta.code === 200000 && data) {
                        if (data?.Code === '200') {
                            this._title.setTitle(
                                data.Data?.type || 'Survey Force - Feedback'
                            );
                            this._storeService.initSurveyData(data);
                            this._storeService.hideLoadingBar();
                            this._postGetSuccessOutside();
                            this._trackingGetSurvey();
                            console.log('App got Survey API Successfully !!!');
                            return data;
                        }
                        error = data.State || '';
                    }
                    this._storeService.hideLoadingBar();
                    this._storeService.navigateToErrorPage(error);
                    this._postGetErrorOutside(error);
                    this._trackingGetSurvey(error);
                    return null;
                }),
                catchError((err) => {
                    const errMsg = err?.error?.State || '';
                    this._storeService.navigateToErrorPage(errMsg);
                    this._postGetErrorOutside(errMsg);
                    this._storeService.hideLoadingBar();
                    this._trackingGetSurvey(errMsg);
                    return of(null);
                })
            );
        }
        return null;
    }

    private _postGetErrorOutside(message: string): void {
        const { uuid = '' } = this._storeService.getAppData();
        const val = JSON.stringify({
            event_name: 'survey_get_error',
            data: message || 'Đã có lỗi xảy ra, vui lòng thử lại sau.',
            uuid,
            fbwc: this._storeService.getFeedbackWebComponentId() || '',
        });

        this._storeService.postMessageOutside(val);
    }

    private _addTheme(): void {
        switch (this._storeService.getPagePath()) {
            case `/${APP_PATH.SURVEY_FORCE_POPUP}`:
                this._storeService.addClassBody(SUPPORT_THEMES_CLASS.POP_UP);
                break;
            case `/${APP_PATH.SURVEY_FORCE_QUIZ}`:
                this._storeService.addClassBody(SUPPORT_THEMES_CLASS.QUIZ);
                break;
            default:
                break;
        }
    }

    private _postGetSuccessOutside(): void {
        const { uuid = '', message_id = '' } = this._storeService.getAppData();
        const mess = JSON.stringify({
            event_name: 'survey_get_success',
            uuid,
            message_id,
            fbwc: this._storeService.getFeedbackWebComponentId() || '',
        });
        this._storeService.postMessageOutside(mess);
    }

    private _trackingGetSurvey(error_message?: string): void {
        const _mtpTrack = this._storeService.getTrackingSdk();
        if (_mtpTrack) {
            const {
                uuid = '',
                message_id = '',
                app_namespace = '',
                user_id = '',
                anonymous_id = '',
            } = this._storeService.getAppData();
            _mtpTrack.sendEvent({
                eventName: 'fb_survey_open',
                properties: {
                    uuid,
                    message_id,
                    host: app_namespace,
                    survey_url: this._storeService.getPageUrl(),
                    user_id,
                    anonymous_id,
                    ...(error_message ? { error_message } : {}),
                },
            });
        }
    }
}
